import { IMatchChangeLmpTemplate } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchChangeSubscription } from './typeguards';
import { CreateLmpMatchChangeInputSchema, LmpMatchChangeMatchInput } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchChangeSubscription } from '../types';
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: LmpMatchChangeSubscription): IMatchChangeLmpTemplate => {
  if (isValidLmpMatchChangeSubscription(obj)) {
    CreateLmpMatchChangeInputSchema().parse(obj.data.onUpdateLmpMatchChangeByMatchId, {reportInput: true});

    const {  matchId, matchList } = obj.data.onUpdateLmpMatchChangeByMatchId;
     
      return {
        matchId,
        matchList: matchList!.map((match) => {
          const { away, home, status, id, link } = match as LmpMatchChangeMatchInput;
          return {
            away,
            home,
            id,
            link,
            status,
          };
        }),
        trackingData: intcmpMap.matchChangeLmp,
      } as IMatchChangeLmpTemplate;

  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchChangeSubscription object',
      data: obj
    });
  }
};
